import { AppNextLink } from '@/features/app-next-link';
import { IconArrowSquareLeft } from '@/components/svg-symbols/icons';
import { PLPPages } from '@/app/(plp)/types';
import usePDPData from '../../_utils/use-pdp-data';
const PDPBreadcrumb = () => {
  const {
    data
  } = usePDPData();
  const brandPath = `/${PLPPages.Brands}/${data?.brand?.slug}`;
  const combinationPath = `${brandPath}/${data?.breadcrumb?.at(-1)?.slug}`;
  return <div className='flex flex-row flex-wrap items-center gap-0.5 text-body-14 text-text-darkGray lg:font-medium' data-sentry-component="PDPBreadcrumb" data-sentry-source-file="pdp-breadcrumb.tsx">
            <AppNextLink prefetch={false} href={brandPath} data-sentry-element="AppNextLink" data-sentry-source-file="pdp-breadcrumb.tsx">
                {data?.brand?.nameFa}
            </AppNextLink>

            <IconArrowSquareLeft className='h-5 w-5' data-sentry-element="IconArrowSquareLeft" data-sentry-source-file="pdp-breadcrumb.tsx" />

            <AppNextLink prefetch={false} href={combinationPath} data-sentry-element="AppNextLink" data-sentry-source-file="pdp-breadcrumb.tsx">
                {`${!!data?.breadcrumb?.length && data.breadcrumb.at(-1)?.nameFa} ${data?.brand?.nameFa}`}
            </AppNextLink>
        </div>;
};
export default PDPBreadcrumb;